<template>
 <div>
    <div class="cls001 cls002" @click="openDialog">
      <img src="@/assets/newicons/id02.png">
    </div>
    <el-drawer size="253px" :visible.sync="drawer" :withHeader="false" :before-close="handleClose" custom-class="miana">
        <div class="list">
          <router-link to="/zxk/junbros/addSite">
          <!-- <i class="iconfont icon-website_fill mr6"></i> -->
          <img style="width:16px;margin-right:6px" src="@/assets/newicons/o01.png" alt="">
          添加站点
          </router-link>
          <router-link to="/zxk/junbros/codeTest">
          <!-- <i class="iconfont icon-daima mr6"></i> -->
          <img style="width:16px;margin-right:6px" src="@/assets/newicons/o02.png" alt="">
          代码检测</router-link>
          <router-link to="/zxk/junbros/codeExplain">
          <!-- <i class="iconfont icon-shuoming mr6"></i> -->
          <img style="width:16px;margin-right:6px" src="@/assets/newicons/o03.png" alt="">
          代码安装说明</router-link>
        </div>
        <div class="Notice">
          <i class="el-icon-info"></i>
          请先部署识别的js识别代码，检测是否部署成功，正确安装统计代码后，一般10分钟左右后，可以查看到相关的识别统计数据，请知晓。
        </div>



        <!-- <div class="setBtnClose" @click="handleClose">
          <img src="@/assets/close.svg">
        </div> -->

        <div class="cls001" style="top: 183px;" @click="handleClose">
          <img src="@/assets/newicons/id02.png">
        </div>


    </el-drawer>
 </div>
</template>

<script>
import { mapState} from 'vuex'
export default {
  data () {
    return {
      drawer: false
    }
  },
  computed:{
    ...mapState({
      staffInfo:state => state.user.staffInfo
    }),
  },
  methods: {
    openDialog () {
      if(this.staffInfo.demonstrationTag == 1){
          this.$message({
                message: '演示账号，无法使用此功能',
                type: 'error'
              });
          return false
      }
      this.drawer = true
    },
    handleClose () {
      this.drawer = false
    }
  }
}
</script>

<style lang="scss" scoped>

.setBtnClose{
   width: 50px;
  height: 43px;
  background: #409eff;
  border-radius: 8px 0px 0px 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
    left: -70px;
    top:-40px;
    img{
      width: 24px;
    }
}
.setBtn {
  width: 50px;
  height: 43px;
  background: #409eff;
  position: fixed;
  right:-5px;
  top: 30%;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}
.Notice {
  margin-top: 16px;
  padding: 9px 13px 9px 38px;
  background: #F2FBFF;
  border-radius: 4px;
  border: 1px solid #CCECFF;
  font-size: 13px;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
  position: relative;
  .el-icon-info{
    position: absolute;
    left: 13px;
    top: 8px;
    font-size: 20px;
    color: rgba(27, 154, 238, 1);
  }
}
.list {
  > a {
    display: flex;
    align-items: center;
    line-height: 32px;
    margin-bottom: 8px;
  }
}
/deep/ .el-drawer {
  // width: 15% !important;
  padding: 0 24px;
  overflow: unset;
}
/deep/ .el-drawer__body{
  padding: 0;
}
/deep/ {
  .miana{
    background-color: #ffffff !important;
    padding-top: 72px;
  }
}
.mr10{
  margin-right: 10px;
}
.mr6{
  margin-right: 6px;
}
.cls001{
  width: 30px;
  height: 30px;
  background: #FFFFFF;
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px 0px 0px 4px;
  position: absolute;
  left: -30px;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  img{
    width: 16px;
    height: 16px;
  }
}
.cls002{
      position: fixed;
    right: 0px;
    // top: 30%;
    top: 183px;
    z-index: 999;
    left: auto;
}
</style>
